import { useId } from 'react';

/**
 * Semnul clinicii de pe ecranul de autentificare.
 *
 * O placă albă, ca butonul principal de pe dentflow.md pus pe un câmp
 * colorat, cu un dinte desenat în culoarea clinicii și inițiala ei pe coroană.
 * Clinica fără siglă primea până acum doar inițiala într-un pătrat — corect,
 * dar nu spunea nimic despre ce fel de loc e. Cu sigla încărcată în Setări,
 * sigla ei stă în aceeași placă și dintele nu se mai desenează.
 *
 * Culorile vin din `--brand`, deci fiecare clinică îl primește în culoarea ei.
 * Mișcarea (plutirea, sclipirea la trecerea mouse-ului) e în CSS și se oprește
 * pentru cine a cerut mișcare redusă.
 */
export function BrandMark({ name, logoUrl }: { name: string; logoUrl?: string | null }) {
  const gradient = useId();
  const initial = name.trim().slice(0, 1).toUpperCase() || 'D';

  return (
    <div className="login__mark" aria-hidden>
      <span className="login__mark-ring" />
      {logoUrl ? (
        <img src={logoUrl} alt="" className="login__logo" />
      ) : (
        <svg className="login__tooth" viewBox="0 0 64 64" role="presentation">
          <defs>
            <linearGradient id={gradient} x1="0" y1="0" x2="1" y2="1">
              <stop offset="0" className="login__tooth-stop1" />
              <stop offset="1" className="login__tooth-stop2" />
            </linearGradient>
          </defs>
          <path
            fill={`url(#${gradient})`}
            d="M21 9c-7 0-12 6-12 14 0 8 3.5 12.5 5.8 19.3C17 49.8 18.3 57 23 57c4.6 0 4.8-10.3 7-14.6 1-2 3-2 4 0 2.2 4.3 2.4 14.6 7 14.6 4.7 0 6-7.2 8.2-14.7C51.5 35.5 55 31 55 23c0-8-5-14-12-14-4.6 0-6.8 2.3-11 2.3S25.6 9 21 9Z"
          />
          <text x="32" y="29" className="login__tooth-initial">
            {initial}
          </text>
        </svg>
      )}
      <span className="login__mark-shine" />
    </div>
  );
}
